import { LockSpec } from '@sparemin/api-sdk';
import { createSelector } from 'reselect';
import { entitiesSelector } from './base';

export const lockSpecsSelector = createSelector(entitiesSelector, entities =>
  entities.get('lockSpecs'),
);

export const lockSpecSelector = (uuid: string) =>
  createSelector(
    lockSpecsSelector,
    lockSpecs => lockSpecs?.get(uuid)?.toJS()?.lockSpec as LockSpec | undefined,
  );
